const LineChartUp01 = ({
  color = 'currentColor',
  width = 21,
  height = 20,
}: {
  color?: string
  width?: number
  height?: number
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M18 17.5H4.33333C3.86662 17.5 3.63327 17.5 3.45501 17.4092C3.29821 17.3293 3.17072 17.2018 3.09083 17.045C3 16.8667 3 16.6334 3 16.1667L3 2.5M17.1667 6.66667L13.9009 10.1522C13.7772 10.2843 13.7153 10.3504 13.6406 10.3845C13.5747 10.4146 13.5021 10.4271 13.43 10.4206C13.3482 10.4132 13.2679 10.3715 13.1072 10.2881L10.3928 8.8786C10.2321 8.79519 10.1518 8.75348 10.07 8.74611C9.99787 8.73961 9.92526 8.75204 9.85936 8.78217C9.78471 8.81631 9.72282 8.88236 9.59906 9.01445L6.33333 12.5"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default LineChartUp01
